(function () {
  console.log('ILM SIZE CHART FIX LOADED');

  function openSizeChart() {
    const modal = document.querySelector('.ilmsc-modal');

    if (!modal) {
      console.warn('ILM modal not found');
      return;
    }

    modal.style.setProperty('display', 'flex', 'important');
    modal.style.setProperty('visibility', 'visible', 'important');
    modal.style.setProperty('opacity', '1', 'important');
    modal.style.setProperty('z-index', '9999999', 'important');

    document.body.classList.add('ilmsc-popup-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSizeChart() {
    const modal = document.querySelector('.ilmsc-modal');

    if (!modal) return;

    modal.style.setProperty('display', 'none', 'important');
    modal.style.setProperty('visibility', 'hidden', 'important');
    modal.style.setProperty('opacity', '0', 'important');

    document.body.classList.remove('ilmsc-popup-open');
    document.body.style.overflow = '';
  }

  document.addEventListener(
    'click',
    function (event) {
      const openButton = event.target.closest('.ilmsc-button');
      const closeButton = event.target.closest('.ilmsc-close');

      if (openButton) {
        event.preventDefault();
        event.stopPropagation();
        openSizeChart();
        return;
      }

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        closeSizeChart();
        return;
      }

      const modal = event.target.closest('.ilmsc-modal');

      if (
        modal &&
        event.target === modal
      ) {
        closeSizeChart();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeSizeChart();
    }
  });
})();